import { Grid, styled, TextField } from "@mui/material";
import { InfoSnackBar } from "components/InfoSnackBar";
import { StyledButton } from "components/StyledButton";
import { ACTIVITIES_FETCH_ERR } from "messages";
import { useState } from "react";
import { api, types } from "api";

const PREFIX = "AddStudentEvaluationPage";

const classes = {
	groups: `${PREFIX}-groups`,
	topicGrade: `${PREFIX}-topicGrade`,
	title: `${PREFIX}-title`,
	button: `${PREFIX}-button`,
	form: `${PREFIX}-form`,
	topicLabel: `${PREFIX}-topicLabel`,
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Root = styled("form")(({ theme }) => ({
	[`&.${classes.form}`]: {
		flexGrow: 1,
		padding: 20,
	},

	[`& .${classes.button}`]: {
		marginRight: 5,
		float: "right",
	},

	[`& .${classes.title}`]: {
		marginTop: 5,
		marginBottom: 15,
		float: "left",
	},
}));

export interface CommentProps {
	studentId: string;
	staffId?: string;
	setSubmitComment: (submitComment: boolean) => void;
}

export const Comment = ({
	studentId,
	staffId,
	setSubmitComment,
}: CommentProps): JSX.Element => {
	const [err, setErr] = useState(false);
	const [newComment, setNewComment] = useState("");

	function onSubmitComment(event: React.FormEvent): void {
		event.preventDefault();

		if (studentId === undefined) {
			setErr(true);
			setSubmitComment(true);
			return;
		}

		if (staffId === undefined) {
			setErr(true);
			setSubmitComment(true);
			return;
		}

		const dto: types.NewComment = {
			studentId: studentId,
			staffId: staffId,
			comment: newComment,
		};

		api
			.addComment({ ...dto })
			.then((res) => {
				if (res.status !== 201) {
					setErr(true);
					setSubmitComment(true);
					return;
				}
				setErr(false);
				setSubmitComment(true);
			})
			.catch(() => {
				setErr(true);
				setSubmitComment(true);
			});
	}

	return (
		<Root className={classes.form} onSubmit={onSubmitComment}>
			<Grid container spacing={1}>
				<Grid item xs={2} />
				<Grid
					item
					xs={10}
					container
					direction="row"
					justifyContent="space-between"
					alignItems="flex-start"
				>
					<Grid item xs={10}>
						<TextField
							sx={{ marginLeft: 2 }}
							id="new-comment-input"
							label="New Comment"
							fullWidth
							multiline
							rows={4}
							placeholder="Comment Content"
							onChange={(e) => setNewComment(e.target.value)}
							value={newComment}
						/>
					</Grid>
					<Grid item xs={2}>
						<StyledButton
							variant="contained"
							color="primary"
							className={classes.button}
							sx={{ marginLeft: 2 }}
							type="submit"
							data-testid="submit-edit-capability"
						>
							Submit Edit
						</StyledButton>
					</Grid>
				</Grid>
			</Grid>

			<InfoSnackBar
				isOpen={err}
				onClose={() => setErr(false)}
				message={ACTIVITIES_FETCH_ERR}
				severity="error"
			/>
		</Root>
	);
};
